// NOTE: NSAI-8009 — same per-request cap as every agent import (the server's
// ArrayMaxSize on the import DTO); a larger selection is sent in batches.
export { AGENT_IMPORT_MAX_AGENTS_PER_REQUEST as MANUS_AUTOMATION_IMPORT_MAX_PER_REQUEST } from "./agent-import";

// NOTE: Shared so web and mobile both hold their import dialog open while an
// import is running (useIsMutating on this key).
export const MANUS_AUTOMATION_IMPORT_MUTATION_KEY = "manus-automation-import";

// NOTE: A Manus export took 89 s on a real account (2026-10-26). Polled every
// 5 s, well inside the server's per-user limits and Manus's 100 reads a
// minute; given up after 5 minutes, when the client offers to resume.
export const MANUS_AUTOMATION_EXPORT_POLL_INTERVAL_MS = 5_000;
export const MANUS_AUTOMATION_EXPORT_TIMEOUT_MS = 5 * 60_000;

// NOTE: Consecutive Manus hiccups (a 5xx, or no answer) a read rides out
// before giving up; seen live, Manus's message API failed for minutes.
export const MANUS_AUTOMATION_EXPORT_MAX_TRANSIENT_FAILURES = 3;

// NOTE: What a Manus instruction writes where its event data goes; passed to
// the translation as a value so i18next does not read it as a placeholder.
export const MANUS_PAYLOAD_PLACEHOLDER = "{{payload}}";
